"use client";

import { useState, useEffect, Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/layout/Layout";
import { TerminalView } from "./components/layout/TerminalView";
import PageLoader from "./components/ui/PageLoader";
import { ErrorBoundary } from "./components/ui/ErrorBoundary";

// Route-level code splitting: each page ships as its own chunk, fetched on
// first visit instead of all being bundled into one ~1.3MB entry file.
const Home = lazy(() => import("./pages/Home"));
const Freeplay = lazy(() => import("./pages/Freeplay"));
const VsAi = lazy(() => import("./pages/VsAi"));
const Battle = lazy(() => import("./pages/Battle"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const FreeplayHistory = lazy(() => import("./pages/FreeplayHistory"));
const VsAiHistory = lazy(() => import("./pages/VsAiHistory"));
const RankedHistory = lazy(() => import("./pages/RankedHistory"));
const Leaderboards = lazy(() => import("./pages/Leaderboards"));
const Custom = lazy(() => import("./pages/Custom"));
const CustomHistory = lazy(() => import("./pages/CustomHistory"));

import { trackPageView } from "./firebase";

export default function App() {
  const location = useLocation();
  const [isRestricted, setIsRestricted] = useState(false);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);


  return (
    <div className="w-screen h-screen bg-black">
      {/* No Suspense here — a boundary wrapping Routes/Layout replaces its
          ENTIRE subtree with the fallback the instant any lazy route
          suspends, Header/Footer included, regardless of keys. That's a
          separate failure mode from the key-remount flicker described below:
          it blanks the whole app to a bare loading screen on every
          navigation to a not-yet-fetched chunk, not just the first load.
          Layout owns its own Suspense scoped to just the outlet content
          (see Layout.jsx) so Header/Footer stay mounted throughout. */}
      <Routes>
        {/* Layout renders its own ErrorBoundary around just the routed
            page content (see Layout.jsx) — wrapping it here instead would
            key/remount Header and Footer on every navigation, reintroducing
            the nav-flicker bug Layout's useOutlet() switch was built to fix. */}
        <Route element={<Layout />}>
          <Route path="/" element={<TerminalView><Home /></TerminalView>} />
          <Route path="/freeplay" element={<TerminalView><Freeplay /></TerminalView>} />
          <Route path="/vs-ai" element={<TerminalView><VsAi /></TerminalView>} />
          <Route path="/battle" element={<TerminalView><Battle /></TerminalView>} />
          <Route path="/history" element={<TerminalView><FreeplayHistory /></TerminalView>} />
          <Route path="/history/vs-ai" element={<TerminalView><VsAiHistory /></TerminalView>} />
          <Route path="/history/ranked" element={<TerminalView><RankedHistory /></TerminalView>} />
          <Route path="/history/custom" element={<TerminalView><CustomHistory /></TerminalView>} />
          <Route path="/leaderboards" element={<TerminalView><Leaderboards /></TerminalView>} />
          <Route path="custom" element={<TerminalView><Custom /></TerminalView>} />
        </Route>

        <Route path="/login" element={<Suspense fallback={<PageLoader />}><ErrorBoundary key="/login"><TerminalView><Login /></TerminalView></ErrorBoundary></Suspense>} />
        <Route path="/register" element={<Suspense fallback={<PageLoader />}><ErrorBoundary key="/register"><TerminalView><Register /></TerminalView></ErrorBoundary></Suspense>} />
      </Routes>
    </div>
  );
}